<template>
  <div class="RollingSegment--Settings" v-loading="isLoading">
    <el-row>
      <el-col :span="12">
        <el-form-item
          :label="$t('CampaignForm_Segments_RollingSegment_Title')"
          prop="rolling_segment_id"
        >
          <el-select
            v-model="segment"
            :filterable="true"
            :placeholder="
              $t('CampaignForm_Segments_RollingSegment_ChooseSegment')
            "
          >
            <el-option
              v-for="(s, i) in selectVariants"
              :key="i"
              :label="s.label"
              :value="s.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="RollingSegment--CalculationInfo" v-if="calculationMessage">
      <span
        class="RollingSegment--CalculationInfoTitle"
        v-if="calculationMessage.title"
      >
        {{ calculationMessage.title }}
      </span>
      <span class="RollingSegment--CalculationInfoMessage">
        {{ calculationMessage.message }}
      </span>
    </el-row>
  </div>
</template>

<script>
import { projectEndpoint, projectTimezoneDate } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import { find } from 'lodash'

export default {
  name: 'RollingSegment',

  props: {
    value: {
      type: Number
    }
  },

  data: function() {
    return {
      segments: [],
      isLoading: false
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `segments`,
        params: {
          type: 1,
          'per-page': 500
        }
      })
    },

    segment: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    currentSegment() {
      if (!this.value) return undefined

      return find(this.segments, i => i.id === this.value)
    },

    calculationMessage() {
      if (!this.currentSegment) return undefined

      if (!this.currentSegment.last_sync_time) {
        return {
          message: this.$t(
            'CampaignForm_Segments_RollingSegment_LastCalculation_CalculationWarning'
          )
        }
      }

      return {
        title: this.$t(
          'CampaignForm_Segments_RollingSegment_LastCalculation_Title'
        ),
        message: projectTimezoneDate(this.currentSegment.last_sync_time).format(
          'YYYY-MM-DD HH:mm'
        )
      }
    },

    selectVariants() {
      return this.segments.map(s => {
        return {
          id: s.id,
          label: s.title
        }
      })
    }
  },

  mounted() {
    this.isLoading = true
    RestApi(this.fetchEndpoint).then(({ data }) => {
      this.segments = data
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.RollingSegment--CalculationInfo {
  padding: 0 10px;
  display: grid;
}

.RollingSegment--CalculationInfoTitle {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}

.RollingSegment--CalculationInfoMessage {
  color: #7e8596;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/RollingSegment.vue